import React from "react";
import { Divider, List } from "antd";
import ChatSidebarHeader from "../../../components/common/ChatSidebarHeader";
import ChatCard from "../../../components/Chat/ChatCard";
import CustomLoader from "../../../components/common/UI/Loader";
import "./index.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

interface ArchivedChatProps {
  loading: boolean;
  handleBackToChats: any;
  handleBlockChat: any;
  handleDeleteConversations: any;
  handleArchiveConversations: any;
  handleMuteConversations: any;
  handlePinConversations: any;
  handleCardClick: any;
}

const ArchivedChats: React.FC<ArchivedChatProps> = ({
  loading,
  handleBackToChats,
  handleBlockChat,
  handleDeleteConversations,
  handleArchiveConversations,
  handleMuteConversations,
  handlePinConversations,
  handleCardClick,
}) => {
  const { archivedChats } = useSelector((state: RootState) => state.chat);

  return (
    <div className="archived-chats-page">
      <ChatSidebarHeader title="Archived" handleBackClick={handleBackToChats} />

      <List
        className="archived-chats-list"
        dataSource={archivedChats}
        loading={{
          spinning: loading,
          indicator: <CustomLoader />,
        }}
        renderItem={(item: any) => (
          <div key={item._id}>
            <ChatCard
              item={item}
              handleClick={handleCardClick}
              handleBlock={() => handleBlockChat(item)}
              handleDelete={() => handleDeleteConversations(item)}
              handleArchive={() => handleArchiveConversations(item)}
              handleMute={() => handleMuteConversations(item)}
              handlePin={() => handlePinConversations(item)}
            />
            <Divider className="divider" />
          </div>
        )}
      />
    </div>
  );
};

export default ArchivedChats;
